import { render, staticRenderFns } from "./WillBeneficiairesDrugsYN.vue?vue&type=template&id=e6951104"
import script from "./WillBeneficiairesDrugsYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiairesDrugsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports